/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PraetorComponentListResponse = zod
	.array(
		zod
			.object({
				enabled: zod.boolean().describe('Whether this component is enabled'),
				policy_plan_id: zod.uuid().nullable(),
				policy_plan_version_id: zod.uuid().nullable(),
				position: zod.number().describe('Ordering position')
			})
			.describe('A versioned praetor component')
	)
	.describe('List of praetor components');

export type PraetorComponentListResponse = zod.input<typeof PraetorComponentListResponse>;
export type PraetorComponentListResponseOutput = zod.output<typeof PraetorComponentListResponse>;
